var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tutorial-layout',{attrs:{"title":"Vue Router","referenceLinks":_vm.referenceLinks,"youtubeLinks":_vm.youtubeLinks}},[_c('p',{attrs:{"slot":"overview"},slot:"overview"},[_vm._v("Overview text goes here.")])])}
var staticRenderFns = []

export { render, staticRenderFns }